import { createSlice } from '@reduxjs/toolkit';

import { LocalizedString } from 'core/constants/remote-config';

export interface LocaleState {
  locale: keyof LocalizedString;
}

const initialState: LocaleState = {
  locale: 'en',
};

const localeSlice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    setLocale: (state, action) => {
      state.locale = action.payload;
    },
  },
});

export const { setLocale } = localeSlice.actions;

export default localeSlice;
